import { initializeDataTableServer } from "./common";

window.sfDocumentReady(['route-applications'], function () {
  window.location.hash = '';
  window.setupDatatable();
  $('.js-clear-filter').hide();
  const applicationTable = initializeDataTableServer(
    $('#application-table'),
    '/search',
    [
      { data: 'job-id' },
      { data: 'name' },
      { data: 'created' },
      { data: 'suburb' },
      { data: 'status' },
      { data: 'type' },
      { data: 'last-update' },
      { data: 'actions' },
    ]
  );

  function reloadData(table, url) {
    $('.statusNav ul li a').removeClass('active-status');
    $('#search_tab').show().addClass("active-status");
    table.ajax.url(url).load();
  };

  $('#sort_filter_application').on('submit', function (e) {
    e.preventDefault();
  });

  $('.js-copy-btn').on('click', function () {
    const targetSelector = $(this).data('copy-target')
    const targetInput = $(targetSelector)

    if (targetInput.length) {
      try {
        targetInput.attr('disabled', false);
        targetInput.trigger('focus');
        targetInput.trigger('select');
        document.execCommand('copy');
        targetInput.attr('disabled', true);

        const btnContent = $(this).html();
        $(this).html('Copied').attr('disabled', true);
        setTimeout(() => {
          $(this).html(btnContent).attr('disabled', false);
        }, 2000);
      } catch (err) {
        $(this).html('Copy failed, please do it manually').attr('disabled', true);
      }
    }
  });
});
